import { RELOAD_TOP_BAR } from '../actions/reduxAction';

const INITIAL_STATE = {
  reload_top_bar: false,
};

export default (state = INITIAL_STATE, action) => {
  // For now only using 'if' for the simplicity
  if (action.type ===
    RELOAD_TOP_BAR) {
    return {
      ...state,
      reload_top_bar: !state.reload_top_bar,
    };
  } else {
    return state;
  }
}
